import { Box, Typography } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import {
  getDepartment,
  getLeavePolicies,
  generateMonthlyReport,
} from 'services/api/modules/leave/leaveReport'
import LeaveSearchSelection from '../LeaveSearchSelection'
import AdxButton from 'components/custom/AdxButton'
import { downloadResponseFile } from 'services/helper/fileDownload'

const MonthlyReportDrawer = () => {
  const [drawerState, setDrawerState] = useState({ right: false })

  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1
  const [selectedYear, setSelectedYear] = useState(currentYear)
  const [selectedMonth, setSelectedMonth] = useState(currentMonth)
  const [selectedDepartment, setSelectedDepartment] = useState([])
  const [selectedLeaveType, setSelectedLeaveType] = useState([])
  const [selectedStatus, setSelectedStatus] = useState([])

  const [departmentArray, setDepartmentArray] = useState([])
  const [leaveTypeArray, setLeaveTypeArray] = useState([])
  const [statusArray, setStatusArray] = useState([])

  // Dummy loading for status data
  // const [statusLoading, setStatusLoading] = useState(true)

  // setTimeout(() => {
  //    setStatusLoading(false)
  // }, 3000);
  // Dummy loading for status data

  const handleDrawer = (anchor, open) => () => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  const getYearArray = () => {
    const yearArray = []

    for (let i = currentYear; i >= 2021; i--) {
      yearArray.push(i)
    }

    return yearArray
  }

  const getMonthArray = () => {
    const monthArray = []

    for (let i = 0; i < 12; i++) {
      const monthName = format(new Date(currentYear, i), 'MMMM')
      monthArray.push({ name: monthName, value: i + 1 })
    }

    return monthArray.reverse()
  }

  const { data: departmentData, isLoading: departmentLoading } = useQuery(
    ['allDepartment'],
    async () => {
      if (drawerState.right) {
        const { data } = await getDepartment()
        return data
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled: drawerState.right,
    }
  )

  const { data: leaveTypeData, isLoading: leaveTypeLoading } = useQuery(
    ['leaveTypes'],
    async () => {
      if (drawerState.right) {
        const { data } = await getLeavePolicies()
        return data
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled: drawerState.right,
    }
  )

  const statusData = [
    // { id: "select", name: "Select" },
    { id: [10, 12, 13, 14, 15], name: 'Pending approval' },
    { id: [17, 18], name: 'Approved' },
    { id: [16], name: 'Withdrawn' },
    { id: [11], name: 'Rejected' },
  ]

  // Export
  const { mutate: exportLeaveReport } = useMutation(generateMonthlyReport, {
    onSuccess: (res) => {
      downloadResponseFile(res, {
        fileName: `${selectedYear}_${selectedMonth}_monthly_leave_report.xlsx`,
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        successMessage: 'Monthly leave report downloaded.',
      })
    },
    onError: (err) => console.error(err),
  })

  const handleExport = () => {
    const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0).getDate()

    const body = {
      start_date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-01`,
      end_date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${lastDayOfMonth}`,
      department_id: selectedDepartment[0].name.includes('All')
        ? departmentData.map((i) => i.id)
        : selectedDepartment.map((i) => i.id),
      leave_policy_id: selectedLeaveType[0].name.includes('All')
        ? leaveTypeData.map((i) => i.id)
        : selectedLeaveType.map((i) => i.id),
      leave_status_id: selectedStatus[0].name.includes('All')
        ? [].concat(...statusData.map((i) => i.id))
        : [].concat(...selectedStatus.map((i) => i.id)),
    }

    exportLeaveReport(body)
  }

  return (
    <>
      <AdxButton
        variant={'contained'}
        sx={{ width: '145px', marginLeft: '16px' }}
        onClick={handleDrawer('right', true)}
      >
        Generate report
      </AdxButton>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        width={{ xs: '100vw', lg: '40vw' }}
        headerprops={<Typography fontWeight="bold">Generate monthly report</Typography>}
        footerprops={
          <Box sx={{ display: 'flex', gap: 1, width: '100%', justifyContent: 'end' }}>
            <AdxButton
              variant={'outlined'}
              sx={{ width: '100px' }}
              onClick={handleDrawer('right', false)}
            >
              Cancel
            </AdxButton>
            <AdxButton variant={'contained'} sx={{ width: '200px' }} onClick={handleExport}>
              Export as xlsx
            </AdxButton>
          </Box>
        }
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            pb: 10,
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              flexDirection: 'column',
              alignItems: 'start',
              width: '100%',
            }}
          >
            <Typography>Select month</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, width: '100%' }}>
              <AdxDropdown
                sx={{ width: 1 / 4 }}
                defaultValue={currentYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {getYearArray().map((i, index) => (
                  <AdxMenuItem key={index} selectedvalue={selectedYear} value={i}>
                    {i}
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
              <AdxDropdown
                sx={{ width: 3 / 4 }}
                defaultValue={currentMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {getMonthArray().map((i, index) => (
                  <AdxMenuItem key={index} selectedvalue={selectedMonth} value={i.value}>
                    {i.name}
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
            </Box>
          </Box>
          <LeaveSearchSelection
            label="Department"
            data={departmentData}
            isLoading={departmentLoading}
            selectedArray={selectedDepartment}
            setSelectedArray={setSelectedDepartment}
            optionsArray={departmentArray}
            setOptionsArray={setDepartmentArray}
          />
          <LeaveSearchSelection
            label="Leave type"
            data={leaveTypeData}
            isLoading={leaveTypeLoading}
            selectedArray={selectedLeaveType}
            setSelectedArray={setSelectedLeaveType}
            optionsArray={leaveTypeArray}
            setOptionsArray={setLeaveTypeArray}
          />
          <LeaveSearchSelection
            label="Status"
            data={statusData}
            // isLoading={statusLoading}
            selectedArray={selectedStatus}
            setSelectedArray={setSelectedStatus}
            optionsArray={statusArray}
            setOptionsArray={setStatusArray}
          />
          {/* <AdxDropdown
                        label="Status"
                        defaultValue="Select"
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {statusArray.map((i, index) => (
                            <AdxMenuItem
                                key={index}
                                selectedvalue={status}
                                value={i.name}
                                disabled={index === 0}
                            >
                                {i.name}
                            </AdxMenuItem>
                        ))}
                    </AdxDropdown> */}
        </Box>
      </AdxDrawerComponent>
    </>
  )
}

export default MonthlyReportDrawer
